import React from 'react';
import { Rifm } from 'rifm';
import styled from 'styled-components';
import InputGroup from '../inputGroup/InputGroup';
import Input2 from '../input/Input2';
import { ThemeColors } from '../../themes/online';

// tslint:disable-next-line:variable-name
const SErrorWrapper = styled.div<{ error: boolean | string | undefined }>(({ theme, error }) => {
  const borderColor = error ? theme.colors.error : theme.colors.border;

  return {
    border: `1px solid ${borderColor}`,
    borderRadius: theme.borderRadiusCommon,
    width: '100%',
  };
});

const isFunction = (functionToCheck: any) => functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';

export interface IInputValueProps {
  error?: boolean | string;
  label: string;
  dataAt: string;
  name?: string;
  onChange?: (event: any) => void;
  onFocus?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputType?: string;
  autoFocus?: boolean;
  value?: string;
  className?: string;
  maxLength?: number;
  placeholder?: string;
  isLogin?: boolean;
  backgroundColor?: string;
  textColor?: ThemeColors;
  pattern?: string;
  dataTestId?: string;
  rifm?: any; // TODO
}

const renderInputWithNativeOnChange =
  (props: any) =>
  ({ value, onChange, error }: { value: undefined | string; onChange: (event: any) => void; error: undefined | boolean | string }) => {
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (isFunction(props.onChange)) {
        props.onChange(event);
      }

      if (isFunction(onChange)) {
        onChange(event);
      }
    };
    return (
      <SErrorWrapper error={error}>
        <Input2 {...props} value={value} onChange={handleOnChange} />
      </SErrorWrapper>
    );
  };

// tslint:disable-next-line: variable-name
const InputForm: React.FC<IInputValueProps> = ({
  value,
  name,
  error,
  inputType = 'text',
  // tslint:disable-next-line: no-empty
  onChange = () => {},
  // tslint:disable-next-line: no-empty
  onFocus = () => {},
  // tslint:disable-next-line: no-empty
  onBlur = () => {},
  autoFocus = false,
  label,
  placeholder = '',
  maxLength,
  className,
  dataAt,
  isLogin = false,
  backgroundColor = 'transparent',
  textColor,
  rifm = null,
  pattern = '',
  dataTestId
}) => {
  const renderInput = renderInputWithNativeOnChange({
    color: textColor,
    name,
    error,
    onChange,
    type: inputType,
    placeholder,
    maxLength,
    onFocus,
    onBlur,
    dataAt: `${dataAt}-input`,
    isLogin,
    backgroundColor,
    pattern,
    autoFocus,
    dataTestId
  });

  return (
    <InputGroup className={className} dataAt={dataAt} label={label} labelColor={textColor}>
      {rifm ? (
        <Rifm {...rifm} onChange={onChange} value={value}>
          {renderInput}
        </Rifm>
      ) : (
        renderInput({ value, onChange, error })
      )}
    </InputGroup>
  );
};

export default InputForm;
